export default "__VITE_ASSET__c7f780ea__"